import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import { setSelection } from '../../store/actions';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5)
    }
  }
}));

const SelectedChip = props => {
  const classes = useStyles();

  const handleDelete = name => () => {
    const { selected } = props.defects;

    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      // Add
      newSelected = [...selected, name];
    } else {
      // Remove
      newSelected = [
        ...selected.slice(0, selectedIndex),
        ...selected.slice(selectedIndex + 1)
      ];
    }
    props.setSelection(newSelected);
  };

  return (
    <div className={classes.root}>
      {props.defects.selected.map((elm, index) => (
        <Chip
          key={index}
          label={props.defects.defectsTable[elm]?.UserCode}
          onDelete={handleDelete(elm)}
          color="secondary"
        />
      ))}
    </div>
  );
};

const mapStateToProps = state => ({
  defects: state.defectReducer
});

const mapDispatchToProps = {
  setSelection
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedChip);
